<template>
  <b-container fluid="xl" class="p-0 g-0 ml-aut0" v-if="loading">
    <crmDashboardSkeleton />
  </b-container>
  <b-container fluid="xl" class="p-0 g-0 ml-aut0" v-if="!loading">
    <b-row>
      <b-col>
        <h3 class="compo-heading ps-0 pt-3">Welcome Back! {{ Username }}</h3>
        <p class="light-txt py-2">
          View summary status of calls, leads, contacts and site visits.
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <TabView class="tabview-custom transaction-tabs callstab" v-model:activeIndex="clases" ref="tabview4"
          scrollable>

          <TabPanel v-for="(tab, index) in menuarray" :key="index">
            <template #header>
              <div @click="TabClick(tab, index)" v-if="tab['StoreRights'] == '1'"
                :class="{ crmwithoutbadge: callscount == 0 }">
                {{ tab["SubMenuName"] }}
              </div>
              <div @click="TabClick(tab, index)" v-if="tab['StoreRights'] == '2'"
                :class="{ crmwithoutbadge: Leadscount == 0 }">
                {{ tab["SubMenuName"] }}
                <Badge v-if="Leadscount !== 0" class="ms-2 count-badge" value="" severity="warning">{{ Leadscount }}
                </Badge>
              </div>
              <div @click="TabClick(tab, index)" v-if="tab['StoreRights'] == '3'"
                :class="{ crmwithoutbadge: Contactscount == 0 }">
                {{ tab["SubMenuName"] }}
                <Badge v-if="Contactscount !== 0" class="ms-2 count-badge" value="" severity="warning">{{ Contactscount
                }}
                </Badge>
              </div>
            </template>
            <div v-if="loading1">
              <crmDashboardSkeleton :headingloader="false" />
            </div>
            <div v-else>
              <div v-if="tab['StoreRights'] == '1'">
                <b-row class="py-2">
                  <b-col class="d-flex flex-row-reverse">
                    <b-tabs class="crmdashtabs" pills card v-model="callIndex">
                      <b-tab title="Today"></b-tab>
                      <b-tab title="This Month"></b-tab>
                      <b-tab title="All"></b-tab>
                    </b-tabs>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="3" md="3" sm="6" cols="6" v-for="(item, index) in callslist">
                    <div class="details-count-cards" :style="bgcolor(item['colour'])"
                      @click="routerto(item.path, item.title, 'Tab1', item.count)">
                      <p>{{ item.title }}</p>
                      <h3>{{ item.count }}</h3>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div v-if="tab['StoreRights'] == '2'">
                <b-row class="py-2">
                  <b-col class="d-flex flex-row-reverse">
                    <b-tabs class="crmdashtabs" pills card v-model="leadIndex">
                      <b-tab title="Today"></b-tab>
                      <b-tab title="This Month"></b-tab>
                      <b-tab title="All"></b-tab>
                    </b-tabs>
                  </b-col>
                </b-row>
                <div v-for="(item, index) in leadslist">
                  <h3 class="compo-heading">{{ item.SourceName }}</h3>
                  <b-row class="py-3">
                    <b-col lg="3" md="3" sm="6" cols="6" class="details-bg">
                      <div class="details-count-cards" :style="bgcolor('#C5D9F1')" @click="
                        routertoLead(
                          item.path,
                          item.query,
                          item,
                          'Tab3',
                          'Total Recevied',
                          item.TotalReceived
                        )
                        ">
                        <p>Total Recevied</p>
                        <h3>{{ item.TotalReceived }}</h3>
                      </div>
                    </b-col>
                    <b-col lg="3" md="3" sm="6" cols="6" class="details-bg">
                      <div class="details-count-cards" :style="bgcolor('#EBF1DE')" @click="
                        routertoLead(
                          item.path,
                          item.query,
                          item,
                          'Tab2',
                          'Total Completed',
                          item.TotalCompleted
                        )
                        ">
                        <p>Total Completed</p>
                        <h3>{{ item.TotalCompleted }}</h3>
                      </div>
                    </b-col>
                    <b-col lg="3" md="3" sm="6" cols="6" class="details-bg">
                      <div class="details-count-cards" :style="bgcolor('#FCD5B4')">
                        <p>Total Followup</p>
                        <h3>{{ item.TotalFollowup }}</h3>
                      </div>
                    </b-col>
                    <b-col lg="3" md="3" sm="6" cols="6" class="details-bg">
                      <div class="details-count-cards" :style="bgcolor('#E4DFEC')" @click="
                        routertoLead(
                          item.path,
                          item.query,
                          item,
                          'Tab3',
                          'Total Dropped',
                          item.TotalDropped
                        )
                        ">
                        <p>Total Dropped</p>
                        <h3>{{ item.TotalDropped }}</h3>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <div v-if="tab['StoreRights'] == '3'">
                <!-- <b-row>
                  <b-col class="d-flex flex-row-reverse">
                    <b-tabs class="crmdashtabs" pills card>
                      <b-tab title="Today"></b-tab>
                      <b-tab title="This Month"></b-tab>
                      <b-tab title="All"></b-tab>
                    </b-tabs>
                  </b-col>
                </b-row> -->
                <b-row class="py-3">
                  <b-col lg="3" md="3" sm="6" cols="6" class="details-bg" v-for="(item, index) in contactslist">
                    <div class="details-count-cards" :style="bgcolor(item['colour'])" @click="
                      routertoContact(
                        item.path,
                        item.query,
                        item?.ContactStatusId,
                        'Tab3'
                      )
                      ">
                      <p>{{ item.title }}</p>
                      <h3>{{ item.count }}</h3>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </TabPanel>
        </TabView>
      </b-col>
    </b-row>
  </b-container>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";
import { useToast } from "primevue/usetoast";
import LiveCallService from "../../service/liveCallsService";
import LeadsService from "../../service/leadService";
import ContactService from "../../service/contactService";
import SiteVisitService from "../../service/siteVisitService";
import MastersService from "../../service/MastersService";
import crmDashboardSkeleton from "../../../../components/SkeletonLoaderComponents/crmDashboardSkeleton.vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";

export default defineComponent({
  components: {
    crmDashboardSkeleton,
  },

  setup() {
    //Declarations
    const router = useRouter();

    const clases = ref(0);
    let callIndex = ref(0);
    let leadIndex = ref(0)
    const toast = useToast();
    let loading = ref(false);
    let loading1 = ref(false);
    let callobjects = ref({
      TodayTotalCalls: 0,
      TodayTotalAnsweredcalls: 0,
      TodayTotalMissedCalls: 0,
      TodayTotalOutgoingCalls: 0,
      TodayTotalIncomingCalls: 0,
      TotalCalls: 0,
      TotalAnsweredcalls: 0,
      TotalMissedCalls: 0,
      TotalOutgoingCalls: 0,
      TotalIncomingCalls: 0,
      TotalIncomingMissedCalls: 0,
      TotalOutgoingMissedCalls: 0,
      TodayIncomingMissedCalls: 0,
      TodayOutgoingMissedCalls: 0,
      TodayInboundRepeatCount: 0,
      TodayOutgoingAnsweredCalls: 0,
      TodayOutboundRepeatCount: 0,
      TotalOutboundRepeatCount: 0,
      LoggedIn: 0,
      NotReady: 0,
      TotalIncomingAnsweredCalls: 0,
      TotalInboundRepeatCount: 0,
      TotalOutgoingAnsweredCalls: 0,
      TotalAgent: 0,
      TotalCallsRepeatCount: 0
    });

    let leadsobjects = ref({
      TotalLeadsCount: 0,
      TodayLeadsCount: 0,
      MissedFollowUpLeads: 0,
      TodayFollowUpLeads: 0,
      OrdersLeads: 0,
      MonthlyLeads: 0,
      LeadStatusList: [],
    });

    let contactsobjects = ref({
      TotalContactsCount: 0,
      TodayContactsCount: 0,
      MissedFollowUpContacts: 0,
      TodayFollowUpContacts: 0,
      OrdersContacts: 0,
      MonthlyContacts: 0,
      ContactStatusList: [],
    });

    let sitevisitobjects = ref({
      SiteVisitScheduled: 0,
      SiteVisitExpected: 0,
      SiteVisitDone: 0,
      TodaySiteVisit: 0,
      ThisWeekSiteVisitCount: 0,
      VeryfiedLeads: 0,
    });

    let callscount = ref(0);
    let Leadscount = ref(0);
    let Contactscount = ref(0);
    let SiteVistcount = ref(0);

    let localstoragedata = ref();
    let agentdidnumber = ref();
    let admin = ref();
    let OrganizationId = ref();
    let UserId = ref();
    let BranchId = ref();
    let AgentId = ref();
    let Username = ref("");

    let menuarray: any = ref([]);
    let CopyCallsList: any = ref([])

    let callslist = ref([
      {
        colour: "",
        title: "Total Recevied",
        count: 0,
        path: "taskDetails",
        query: "1",
        TabValue: "Tab1",
      },
      {
        colour: "",
        title: "Total Answered",
        count: 0,
        path: "taskDetails",
        query: "2",
        TabValue: "Tab1",
      },
      {
        colour: "",
        title: "Total Abandoned",
        count: 0,
        path: "taskDetails",
        query: "3",
        TabValue: "Tab1",
      },
      {
        colour: "",
        title: "Repeat Calls",
        count: 0,
        path: "taskDetails",
        query: "4",
        TabValue: "Tab1",
      },
      {
        colour: "",
        title: "Total Outbound",
        count: 0,
        path: "taskDetails",
        query: "5",
        TabValue: "Tab1",
      },
      {
        colour: "",
        title: "Total Outbound Contacted",
        count: 0,
        path: "taskDetails",
        query: "6",
        TabValue: "Tab1",
      },
      {
        colour: "",
        title: "Total Outbound Not Contacted",
        count: 0,
        path: "taskDetails",
        query: "7",
        TabValue: "Tab1",
      },
      {
        colour: "",
        title: "No of Outbound Attempts",
        count: 0,
        path: "taskDetails",
        query: "8",
        TabValue: "Tab1",
      },
      {
        colour: "",
        title: "Overall Calls",
        count: 0,
        path: "taskDetails",
        query: "9",
        TabValue: "Tab1",
      },
      {
        colour: "",
        title: "Overall Answered Calls",
        count: 0,
        path: "taskDetails",
        query: "10",
        TabValue: "Tab1",
      },
      {
        colour: "",
        title: "Overall Abandoned Calls",
        count: 0,
        path: "taskDetails",
        query: "11",
        TabValue: "Tab1",
      },
      {
        colour: "",
        title: "Overall Repeat Calls",
        count: 0,
        path: "taskDetails",
        query: "12",
        TabValue: "Tab1",

      },
      {
        colour: "",
        title: "Total Agents",
        count: 0,
        path: "agentTableView",
        query: "13",
        TabValue: "Tab1",

      },
      {
        colour: "",
        title: "Logged In",
        count: 0,
        path: "agentTableView",
        query: "14",
        TabValue: "Tab1",
      },
      {
        colour: "",
        title: "Not Ready Mode",
        count: 0,
        path: "agentTableView",
        query: "15",
        TabValue: "Tab1",
      },

    ]);

    let leadslist: any = ref([])

    // let leadslist: any = ref([
    //   {
    //     colour: "",
    //     title: "Total Leads",
    //     count: 0,
    //     path: "taskDetails",
    //     query: "1",
    //     LeadStatusId: 0,
    //     TabValue: "Tab2",
    //     SourceName: ""
    //   },
    //   {
    //     colour: "",
    //     title: "Today Leads",
    //     count: 0,
    //     path: "taskDetails",
    //     query: "2",
    //     LeadStatusId: 0,
    //     TabValue: "Tab2",
    //     SourceName: ""
    //   },
    //   {
    //     colour: "",
    //     title: "Today Follow Up",
    //     count: 0,
    //     path: "taskDetails",
    //     query: "3",
    //     LeadStatusId: 0,
    //     TabValue: "Tab2",
    //     SourceName: ""
    //   },
    //   {
    //     colour: "",
    //     title: "Missed Follow Up",
    //     count: 0,
    //     path: "taskDetails",
    //     query: "4",
    //     LeadStatusId: 0,
    //     TabValue: "Tab2",
    //     SourceName: ""
    //   },

    //   {
    //     colour: "",
    //     title: "Total Leads of Month",
    //     count: 0,
    //     path: "taskDetails",
    //     query: "6",
    //     LeadStatusId: 0,
    //     TabValue: "Tab2",
    //     SourceName: ""
    //   },
    // ]);

    let contactslist = ref([
      {
        colour: "",
        title: "Total Contacts",
        count: 0,
        path: "taskDetails",
        query: "1",
        ContactStatusId: 0,
        TabValue: "Tab3",
      },
      {
        colour: "",
        title: "Today Contacts",
        count: 0,
        path: "taskDetails",
        query: "2",
        ContactStatusId: 0,
        TabValue: "Tab3",
      },
      {
        colour: "",
        title: "Today Follow Up",
        count: 0,
        path: "taskDetails",
        query: "3",
        ContactStatusId: 0,
        TabValue: "Tab3",
      },
      {
        colour: "",
        title: "Missed Follow Up",
        count: 0,
        path: "taskDetails",
        query: "4",
        ContactStatusId: 0,
        TabValue: "Tab3",
      },
      {
        colour: "",
        title: "Total Contacts of Month",
        count: 0,
        path: "taskDetails",
        query: "6",
        ContactStatusId: 0,
        TabValue: "Tab3",
      },
    ]);

    let sitevisitlist = ref([
      {
        colour: "#FCD5B4",
        title: "Site Visit Scheduled",
        count: 0,
        path: "taskDetails",
        query: "1",
        TabValue: "Tab4",
      },
      {
        colour: "#DDD6FC",
        title: "Site Visit Expected",
        count: 0,
        path: "taskDetails",
        query: "2",
        TabValue: "Tab4",
      },
      {
        colour: "#F9EAC9",
        title: "Site Visit Done",
        count: 0,
        path: "taskDetails",
        query: "3",
        TabValue: "Tab4",
      },
      {
        colour: "#DDD6FC",
        title: "Today Site Visit",
        count: 0,
        path: "taskDetails",
        query: "4",
        TabValue: "Tab4",
      },
      {
        colour: "#F9D9E7",
        title: "This Week Site Visit",
        count: 0,
        path: "taskDetails",
        query: "5",
        TabValue: "Tab4",
      },
      // {
      //     colour: "#F9D9E7", title: "RNR", count: 0, path: "taskDetails", query: "6"
      // },
      {
        colour: "#DDD6FC",
        title: "Verified Leads",
        count: 0,
        path: "taskDetails",
        query: "7",
        TabValue: "Tab4",
      },
    ]);

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    // localstoragedata.value = localStorage.getItem("UsersData");
    // localstoragedata.value = JSON.parse(localstoragedata.value);
    // agentdidnumber.value = localstoragedata.value.AgentDid;
    // admin.value = localstoragedata.value.Admin;
    // OrganizationId.value = localstoragedata.value.OrganizationId;
    // BranchId.value = localstoragedata.value.BranchId;
    // UserId.value = localstoragedata.value.UserId;
    // AgentId.value = localstoragedata.value.AgentId;
    // Username.value = localstoragedata.value.UserName;

    onMounted(() => {
      debugger;
      ReadyFunction();
    });

    async function ReadyFunction() {
      debugger;

      await LoadMenus();
      await IsCallList(callIndex.value + 1);
      await IsLeadsList(leadIndex.value + 1);
      await IsContactsList();
      // await IsSiteVisitList();
    }

    async function LoadMenus() {
      debugger;
      let response = await MastersService.GetMenus(
        5,
        rolesData.RoleId,
        usersData.ApplicationType,
        usersData.OrganizationId
      );

      console.log("DashBoardTabList", response["result"]);

      menuarray.value = response["result"];

      if (menuarray.value.length > 0) {
        TabClick(menuarray.value[0], 0);
      }
    }

    // async function GetRightsByRoleId() {
    //   debugger;
    //   loading.value = true;
    //   let ModuleId = 5;

    //   let GetRightsResponse = await EntityMasterservice.GetRightsByRoleId(
    //     rolesData.RoleId,
    //     ModuleId,
    //     usersData.OrganizationId
    //   );

    //   LoadMenus();
    // }

    let functionRights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    const activeTabIndex = ref(0);

    async function TabClick(SubMenuDetails, index) {
      debugger;
      loading1.value = true;
      activeTabIndex.value = index;
      console.log("SubMenuEntityId", SubMenuDetails.EntityId);

      let InstantEntityId = {
        EntityId: SubMenuDetails.EntityId,
      };
      localStorage.removeItem("EntityData");
      localStorage.setItem("EntityData", JSON.stringify(InstantEntityId));

      const response = await MastersService.CheckMenuRights(
        InstantEntityId.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      let Rights = ref({
        Create: false,
        Update: false,
        Read: false,
        Delete: false,
      });

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;

          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;

          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;

          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;

          Rights.value.Delete = operation.IsActive;
        }
      }

      functionRights.value.Create = Rights.value.Create;
      functionRights.value.Update = Rights.value.Update;
      functionRights.value.Read = Rights.value.Read;
      functionRights.value.Delete = Rights.value.Delete;
      setTimeout(() => {
        loading1.value = false;
      }, 500);
    }

    const bgcolor = (data) => {
      return {
        backgroundColor: data,
        padding: "15px 10px 15px 10px",
        margin: "10px 0",
      };
    };

    //Functions
    function routerto(path, query, TabValue, Value) {
      debugger;

      if (Value > 0) {
        if (!['Total Agents', 'Logged In', 'Not Ready Mode'].includes(query)) {
          router.push({
            path: "/" + path,
            // name: path,
            query: {
              CallStatus: query,
              TabValue: TabValue,
              filter: callIndex.value + 1
            },
          });
        } else {
          router.push({
            path: "/" + path,
            // name: path,
            query: {
              AgentStatus: query,
            },
          });
        }
      }


    }

    function routertoLead(path, query, data, TabValue, callStatus, Value) {
      debugger;
      if (Value > 0) {
        if (callStatus == 'Total Completed') {
          router.push({
            path: "/" + path,
            // name: path,
            query: {
              CallStatus: callStatus,
              LeadStatus: data.SourceType,
              LeadStatusId: data.SourceId,
              TabValue: TabValue,
              filter: leadIndex.value + 1
            },
          });
        } else if (data.SourceType != 'Status' && (callStatus == 'Total Recevied' || callStatus == 'Total Dropped') && TabValue == 'Tab3') {
          router.push({
            path: "/" + path,
            // name: path,
            query: {
              CallStatus: callStatus,
              ContactStatusVal: data.SourceType,
              ContactStatusId: data.SourceId,
              TabValue: TabValue,
              filter: leadIndex.value + 1
            },
          });
        }
      }
    }


    function routertoContact(path, query, ContactStatusId, TabValue) {
      debugger;
      router.push({
        path: "/" + path,
        // name: path,
        query: {
          ContactStatus: query,
          ContactStatusId: ContactStatusId,
          TabValue: TabValue,
        },
      });
    }

    function routersite(path, query, TabValue) {
      router.push({
        path: "/" + path,
        // name: path,
        query: {
          SitevisitStatus: query,
          TabValue: TabValue,
        },
      });
    }

    let List = ref([]);
    const IsCallList = async (flag) => {
      debugger;
      try {
        debugger;
        loading1.value = true;

        const response = await LiveCallService.GetDashboardCallListCustom(
          usersData.AgentId,
          usersData.Admin,
          usersData.OrganizationId,
          flag
        );

        console.log(response);
        Object.assign(callobjects.value, response["result"]);
        console.log(callobjects);

        const callCounts = {
          "Total Recevied": callobjects.value.TotalIncomingCalls,
          "Total Answered": callobjects.value.TotalIncomingAnsweredCalls,
          "Total Abandoned": callobjects.value.TotalIncomingMissedCalls,
          "Repeat Calls": callobjects.value.TotalInboundRepeatCount,
          "Total Outbound": callobjects.value.TotalOutgoingCalls,
          "Total Outbound Contacted": callobjects.value.TotalOutgoingAnsweredCalls,
          "Total Outbound Not Contacted": callobjects.value.TotalOutgoingMissedCalls,
          "No of Outbound Attempts": callobjects.value.TotalOutboundRepeatCount,
          "Total Agents": callobjects.value.TotalAgent,
          "Logged In": callobjects.value.LoggedIn,
          "Not Ready Mode": callobjects.value.NotReady,
          "Overall Calls": callobjects.value.TotalCalls,
          "Overall Answered Calls": callobjects.value.TotalAnsweredcalls,
          "Overall Abandoned Calls": callobjects.value.TotalMissedCalls,
          "Overall Repeat Calls": callobjects.value.TotalCallsRepeatCount
        };

        callslist.value.forEach((call, index) => {
          if (callCounts[call.title] !== undefined) {
            call.count = callCounts[call.title];
            if (index % 4 == 0) {
              call.colour = "#C5D9F1"
            } else if (index % 4 == 1) {
              call.colour = "#EBF1DE"
            } else if (index % 4 == 2) {
              call.colour = "#FCD5B4"
            } else if (index % 4 == 3) {
              call.colour = "#E4DFEC"
            }
          }
        });


        // callslist.value[0].count = callobjects.value.TodayTotalCalls;
        // callslist.value[3].count = callobjects.value.TodayTotalAnsweredcalls;
        // callslist.value[4].count = callobjects.value.TodayTotalMissedCalls;
        // callslist.value[1].count = callobjects.value.TodayTotalIncomingCalls;
        // callslist.value[2].count = callobjects.value.TodayTotalOutgoingCalls;
        // callslist.value[7].count = callobjects.value.TotalCalls;
        // callslist.value[10].count = callobjects.value.TotalAnsweredcalls;
        // callslist.value[5].count = callobjects.value.TodayIncomingMissedCalls;
        // callslist.value[6].count = callobjects.value.TodayOutgoingMissedCalls;
        // callslist.value[11].count = callobjects.value.TotalMissedCalls;
        // callslist.value[8].count = callobjects.value.TotalIncomingCalls;
        // callslist.value[9].count = callobjects.value.TotalOutgoingCalls;

        callscount.value = callslist.value[1].count;
        CopyCallsList.value = callslist.value;
        callslist.value = CopyCallsList.value
        loading1.value = false;
      } catch (error) {
        loading1.value = false;

        // alert(error);
      }
    };

    const IsLeadsList = async (flag) => {
      debugger;
      try {
        debugger;
        loading1.value = true;

        const response = await LeadsService.GetLeadDashboardStats(
          usersData.OrganizationId,
          usersData.BranchId,
          usersData.AgentId,
          usersData.Admin,
          flag
        );

        console.log(response);
        leadslist.value = response["result"];
        let count = 0;
        leadslist.value = leadslist.value.map((i1: any, index) => {
          i1.path = "taskDetails";
          i1.query = "7";

          return i1;
        });

        Leadscount.value = leadslist.value[0].TotalReceived;
        loading1.value = false;
      } catch (error) {
        loading1.value = false;
      }
    };

    const IsContactsList = async () => {
      debugger;
      try {
        debugger;
        loading.value = true;

        const response = await ContactService.getContactDashboardListCustom(
          usersData.BranchId,
          usersData.AgentId,
          usersData.Admin,
          usersData.OrganizationId
        );
        console.log(response);
        Object.assign(contactsobjects.value, response["result"]);
        console.log(leadsobjects);
        // contactslist.value[0].count = contactsobjects.value.TotalContactsCount;
        // contactslist.value[1].count = contactsobjects.value.TodayContactsCount;
        // contactslist.value[2].count =
        //   contactsobjects.value.TodayFollowUpContacts;
        // contactslist.value[3].count =
        //   contactsobjects.value.MissedFollowUpContacts;
        // contactslist.value[4].count = contactsobjects.value.MonthlyContacts;

        const contactCounts = {
          "Total Contacts": contactsobjects.value.TotalContactsCount,
          "Today Contacts": contactsobjects.value.TodayContactsCount,
          "Today Follow Up": contactsobjects.value.TodayFollowUpContacts,
          "Missed Follow Up": contactsobjects.value.MissedFollowUpContacts,
          "Total Contacts of Month": contactsobjects.value.MonthlyContacts,
        };

        contactslist.value.forEach((contact) => {
          if (contactCounts[contact.title] !== undefined) {
            contact.count = contactCounts[contact.title];
          }
        });

        contactsobjects.value.ContactStatusList.map((i1: any) => {

          i1.path = "taskDetails";
          i1.query = "7";
          return i1;
        });
        contactslist.value.push(...contactsobjects.value.ContactStatusList);
        contactslist.value = contactslist.value.map((i1: any, index) => {

          if (index % 4 == 0) {
            i1.colour = "#C5D9F1"
          } else if (index % 4 == 1) {
            i1.colour = "#EBF1DE"
          } else if (index % 4 == 2) {
            i1.colour = "#FCD5B4"
          } else if (index % 4 == 3) {
            i1.colour = "#E4DFEC"
          }

          return i1;
        });
        Contactscount.value = contactslist.value[0].count;
        loading.value = false;
      } catch (error) {
        loading.value = false;

        // alert(error);
      }
    };

    const IsSiteVisitList = async () => {
      debugger;
      try {
        debugger;
        loading.value = true;

        const response = await SiteVisitService.GetSiteVisitDashboardCustom(
          usersData.BranchId,
          usersData.AgentId,
          usersData.Admin,
          usersData.OrganizationId
        );

        console.log(response);
        Object.assign(sitevisitobjects.value, response["result"]);
        console.log(sitevisitobjects);
        sitevisitlist.value[0].count =
          sitevisitobjects.value.SiteVisitScheduled;
        sitevisitlist.value[1].count = sitevisitobjects.value.SiteVisitExpected;
        sitevisitlist.value[2].count = sitevisitobjects.value.SiteVisitDone;
        sitevisitlist.value[3].count = sitevisitobjects.value.TodaySiteVisit;
        sitevisitlist.value[4].count =
          sitevisitobjects.value.ThisWeekSiteVisitCount;
        sitevisitlist.value[5].count = sitevisitobjects.value.VeryfiedLeads;

        SiteVistcount.value = sitevisitlist.value[0].count;
        loading.value = false;
      } catch (error) {
        loading.value = false;

        // alert(error);
      }
    };

    watch(
      () => callIndex.value,
      () => {
        IsCallList(callIndex.value + 1)
      }
    );

    watch(
      () => leadIndex.value,
      () => {
        IsLeadsList(leadIndex.value + 1)
      }
    );

    return {
      clases,
      callslist,
      bgcolor,
      leadslist,
      contactslist,
      sitevisitlist,
      routerto,
      routertoLead,
      routertoContact,
      callscount,
      SiteVistcount,
      Leadscount,
      Contactscount,
      routersite,
      Username,
      menuarray,
      TabClick,
      loading,
      loading1,
      callIndex,
      leadIndex
    };
  },
});
</script>

<style lang="scss" scoped>
.details-count-cards {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 95px;
}

.details-count-cards:hover {
  box-shadow: 0 4px 8px 0 #999999;
  cursor: pointer;
}

.details-count-cards p {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
}

.details-count-cards h3 {
  text-align: center;
  font-size: 21px;
  color: #444;
  font-weight: bolder;
}

@media only screen and (max-width: 545px) {
  .details-count-cards p {
    font-size: 13px;
  }
}

// .details-bg :nth-child(odd):not(.details-count-cards) {
//     background-color: yellow;
// }

// .details-bg :nth-child(even):not(.details-count-cards) {
//     background-color: orange;
// }
.compo-heading {
  margin-bottom: -5px;
}
</style>

<style lang="scss">
.callstab .p-tabview-panels {
  background-color: #f8f9fe !important;
}

.callstab .p-badge {
  font-size: 0.6rem;
  min-width: 1.3rem;
  height: 1.3rem;
  line-height: 1.3rem;
  margin-left: 5px !important;
}
</style>

<style>
@import '../../../../assets/variables.scss';

.crmdashtabs .card-header li {
  /* margin: 5px; */
}

.crmdashtabs .card-header-tabs .nav-link.active {
  background-color: #4582ff;
  border: 1px solid #4582ff;
  border-radius: 0px;
  color: white;
  padding: 6px 9px;
  font-size: 14px;
}

.crmdashtabs .card-header-tabs .nav-link {
  background-color: #f0f4f8;
  border: 1px solid #e1e1e1;
  border-radius: 0px;
  /* margin: 0px 5px; */
  padding: 6px 9px;
  font-size: 14px;
  color: #333333;
}

.crmdashtabs .card-header-tabs {
  /* margin: 1% 10px; */
}

.crmdashtabs .tab-content {
  /* margin: 2% 1%; */
}

.crmdashtabs .nav-item:first-child .nav-link {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.crmdashtabs .nav-item:last-child .nav-link {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
</style>
